/**
 * @desc 订单修改备注
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.UpdateRemarkDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/updateRemark`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
